import { Divider, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';

import { getRevivalReasonLabel, revivalReasons } from 'shared/models/scheduled-outreach';

interface OutreachRevivalMenuProps {
    value: string;
    onChange: (event: React.ChangeEvent<{ value: string }>) => void;
}

export const OutreachRevivalMenu: React.FC<OutreachRevivalMenuProps> = ({ value, onChange }) => {
    const disqualMenuItems = revivalReasons.map((reason) => (
        <MenuItem key={reason} value={reason}>
            {getRevivalReasonLabel(reason)}
        </MenuItem>
    ));
    const revivalOpts = [
        <MenuItem key="never_responded" disabled={true}>
            Never Responded
        </MenuItem>,
        <Divider key="divider1" />,
        <MenuItem value="never_responded" key="email-not-responded">
            Email candidates who have not been contacted in a while
        </MenuItem>,
        <Divider key="divider2" />,
        <MenuItem key="disqualified" disabled={true}>
            Disqualified Candidates
        </MenuItem>,
        <Divider key="divider3" />,
        ...disqualMenuItems
    ];
    return (
        <FormControl fullWidth={true}>
            <InputLabel id="outreach-sequence-revival-reason-label">Select Revival Reason</InputLabel>
            <Select value={value} onChange={onChange} labelId="outreach-sequence-revival-reason-label">
                {revivalOpts}
            </Select>
        </FormControl>
    );
};
